// extracted by mini-css-extract-plugin
export default {"pageLayout":"PlasmicPageLayout_pageLayout__MdnlA","sidenavSpacer":"PlasmicPageLayout_sidenavSpacer__iud5f","slotPageContent":"PlasmicPageLayout_slotPageContent__6DLpF"};